import React, { Component } from 'react';
import { Col, Card, CardBody, Row } from "reactstrap";
import Label from '../../components/Common/Label';
import { Grid } from '@mui/material';

class MiniWidgets extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }
    overviewCard = (title, value, valueUnit, isMoney, isIncrease, rate) => {
        return (
            <Grid item key={title} lg={3} md={6} sm={6} xs={12}>
                <Card className='card-container' style={{ background: 'white', padding: 0, width: '100%' }}>
                    <CardBody className='d-flex align-items-center'>
                        <Row className='m-0 d-flex w-100 align-items-baseline flex-wrap'>
                            <Col xs={12} md={12} className='p-0 card-title'>{title}</Col>
                            <Col xs={12} md={12} className='d-flex justify-content-between align-items-baseline flex-wrap p-0'>
                                <div className='d-flex align-items-baseline p-0 card-value'>
                                    {
                                        isMoney && <span style={{ fontFamily: 'Manrope', fontSize: 14, marginRight: 5 }}>S$</span>
                                    }
                                    {value} {valueUnit && <div style={{ fontFamily: 'Manrope', fontSize: 14, marginLeft: 5 }}>{valueUnit}</div>}
                                </div>
                                <div className="d-flex align-items-baseline p-0 " style={{ color: isIncrease ? '#34C759' : '#ED1A3D' }}>
                                    <i className={`${isIncrease ? 'ri-arrow-up-line' : 'ri-arrow-down-line'} m-0`} style={{ marginRight: 5 }} />{rate}
                                </div>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </Grid>
        )
    }
    render() {
        return (
            <React.Fragment>
                <Grid container className='' spacing={2} mt={0.5}>
                    {this.overviewCard('Total revenue', this.props?.reports?.this_week_total_sales || "0.00", null, true, !this.props?.reports?.sales_percentage_change?.includes("-"), this.props?.reports?.sales_percentage_change || '0')}
                    {this.overviewCard('Total sales', this.props?.reports?.this_week_orders || "0", 'orders', false, !this.props?.reports?.orders_percentage_change?.includes("-"), this.props?.reports?.orders_percentage_change)}
                    {this.overviewCard('Average order value', this.props?.reports?.this_week_aov || "0.00", null, true, !this.props?.reports?.aov_percentage_change?.includes("-"), this.props?.reports?.aov_percentage_change)}
                    {this.overviewCard('New customers', this.props?.reports?.this_week_new_customers || "0", 'customers', false, !this.props?.reports?.new_customers_percentage_change?.includes("-"), this.props?.reports?.new_customers_percentage_change)}
                </Grid>
            </React.Fragment>
        );
    }
}

export default MiniWidgets;